function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Card, Modal, Space, Select, Tag, Segmented, Drawer, Input, Form, Statistic, DatePicker, Divider, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { PrinterFill, Download as DownloadIc, Receipt, CheckCircleFill, ArrowLeftCircleFill, List, EyeFill, ArrowRightCircleFill, Bank2 } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import moment from 'moment';
import CreateInvoice from "../components/CreateInvoice";
import dayjs from 'dayjs';
import BillConfirm from "../components/BillConfirm";
import BillCheckList from "../components/BillCheckList";
import BillDisplay from "../components/BillDisplay";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var Facturation = function Facturation() {
  var ref = useRef();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compOptions = _useState4[0],
    setCompOptions = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentCustomer = _useState8[0],
    setCurrentCustomer = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showCertificate = _useState0[0],
    setShowCertificate = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    dataChanged = _useState10[0],
    setDataChanged = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showInvoice = _useState12[0],
    setShowInvoice = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    currentCompany = _useState14[0],
    setCurrentCompany = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedCandidates = _useState16[0],
    setSelectedCandidates = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    listConfirmed = _useState18[0],
    setListConfirmed = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    confirmLoading = _useState20[0],
    setConfirmLoading = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    currentTotalAmount = _useState22[0],
    setCurrentTotalAmount = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    billsLoading = _useState24[0],
    setBillsLoading = _useState24[1];
  var _useState25 = useState(120),
    _useState26 = _slicedToArray(_useState25, 2),
    limit = _useState26[0],
    setLimit = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    offset = _useState28[0],
    setOffset = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    bills = _useState30[0],
    setBills = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showBill = _useState32[0],
    setShowBill = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showBillList = _useState34[0],
    setShowBillList = _useState34[1];
  var _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    selectedBill = _useState36[0],
    setSelectedBill = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    selectedBillCandidates = _useState38[0],
    setSelectedBillCandidates = _useState38[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState39 = useState(dayjs().subtract(1, 'months').startOf('month').format()),
    _useState40 = _slicedToArray(_useState39, 2),
    from = _useState40[0],
    setFrom = _useState40[1];
  var _useState41 = useState(dayjs().subtract(1, 'months').endOf('month').format()),
    _useState42 = _slicedToArray(_useState41, 2),
    to = _useState42[0],
    setTo = _useState42[1];
  var handleCompanyChange = function handleCompanyChange(v) {
    if (compOptions.filter(function (c) {
      return c.value == v;
    }).length > 0) {
      setCurrentCompany(compOptions.filter(function (c) {
        return c.value == v;
      })[0]);
    }
    setIsDataLoading(true);
    axios.post(Common.baseApiUrl + "getcustomersforbilling", {
      company_id: v,
      user_id: Common.currentUser.id,
      from: dayjs(from).format(),
      to: dayjs(to).format()
    }).then(function (response) {
      setSelectedCandidates([]);
      if (response.data.status == 200) {
        response.data.customers.forEach(function (e) {
          setSelectedCandidates(function (prev) {
            return [].concat(_toConsumableArray(prev), [e]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  var handlePeriodChange = function handlePeriodChange(dates, dateStrings) {
    setFrom(dayjs(dates[0]).format());
    setTo(dayjs(dates[1]).format());
    setIsDataLoading(true);
    axios.post(Common.baseApiUrl + "getcustomersforbilling", {
      company_id: currentCompany.value,
      user_id: Common.currentUser.id,
      from: dayjs(dates[0]).format(),
      to: dayjs(dates[1]).format()
    }).then(function (response) {
      setSelectedCandidates([]);
      if (response.data.status == 200) {
        response.data.customers.forEach(function (e) {
          setSelectedCandidates(function (prev) {
            return [].concat(_toConsumableArray(prev), [e]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  var handleBillCreate = function handleBillCreate() {
    var id_array = [];
    selectedCandidates.forEach(function (c) {
      id_array.push(c.id.toString());
    });
    setConfirmLoading(true);
    var fd = new FormData();
    fd.append("company_id", currentCompany.value);
    fd.append("candidates", id_array.join(","));
    fd.append("total_amount", currentTotalAmount);
    axios.post(Common.baseApiUrl + "createbill", fd).then(function (response) {
      if (response.data.status == 200) {
        notification.success({
          message: "Ok !",
          description: response.data.message
        });
        setShowInvoice(false);
        setDataChanged(true);
      } else {
        notification.error({
          message: "Erreur!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setConfirmLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        if (response.data.companyList.length > 0) {
          form.setFieldsValue({
            company_id: response.data.companyList[0].id
          });
          setCurrentCompany(response.data.companyList[0]);
        }
      } else {
        notification.success({
          message: "Ok !",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    setBillsLoading(true);
    axios.get(Common.baseApiUrl + 'getbills/' + limit.toString() + "/" + offset.toString() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setBills([]);
        response.data.bills.forEach(function (b) {
          setBills(function (prev) {
            return [].concat(_toConsumableArray(prev), [b]);
          });
        });
      } else {
        notification.success({
          message: "Ok !",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenuee " + error.toString()
      });
    })["finally"](function () {
      setBillsLoading(false);
    });
  }, [dataChanged, limit, offset]);
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Receipt, {
        size: 22
      }), " FACTURES "]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: bills.map(function (b) {
          return /*#__PURE__*/_jsxs(Col, {
            lg: 4,
            md: 4,
            sm: 6,
            children: [/*#__PURE__*/_jsxs(Card, {
              actions: [/*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setSelectedBill(b);
                  setSelectedBillCandidates([]);
                  b.bill_customers.forEach(function (bc) {
                    setSelectedBillCandidates(function (prev) {
                      return [].concat(_toConsumableArray(prev), [bc.customer]);
                    });
                  });
                  setShowBill(true);
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EyeFill, {
                    size: 17
                  }), " Voir facture"]
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setSelectedBill(b);
                  setSelectedBillCandidates([]);
                  b.bill_customers.forEach(function (bc) {
                    setSelectedBillCandidates(function (prev) {
                      return [].concat(_toConsumableArray(prev), [bc.customer]);
                    });
                  });
                  setShowBillList(true);
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Receipt, {
                    size: 17
                  }), " List candidats"]
                })
              })],
              title: b.company && b.company.label,
              bordered: false,
              children: [/*#__PURE__*/_jsx("b", {
                children: b.total_amount && b.total_amount.toLocaleString("Fr")
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Moment, {
                date: b.created_at,
                format: "DD/MM/YYYY"
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          }, b.id);
        })
      }), billsLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Bank2, {
        size: 22
      }), " COMPTES SOCIETES "]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {})
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#FACTURATION ENTREPRISES"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            style: {
              padding: "25px",
              background: "#FFFFFF",
              borderRadius: "3px",
              boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            },
            form: form,
            layout: "vertical",
            onFinish: function onFinish(values) {
              if (selectedCandidates.length == 0) notification.error({
                message: "Erreur",
                description: "Aucun candidat à facturer"
              });
              if (currentCompany == null || currentCompany == 'undefined') notification.error({
                message: "Erreur",
                description: "Veuillez sélectionner une société"
              });
              setShowInvoice(true);
            },
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 5,
                md: 5,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "company_id",
                  children: /*#__PURE__*/_jsx(Select, {
                    onChange: handleCompanyChange,
                    options: compOptions,
                    style: {
                      width: "100%"
                    }
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 5,
                md: 5,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "period",
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    needConfirm: false,
                    onChange: handlePeriodChange,
                    showTime: {
                      format: 'HH:mm'
                    },
                    format: "DD-MM-YYYY HH:mm"
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  loading: isDataLoading,
                  disabled: selectedCandidates.length == 0,
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(Receipt, {
                      size: 22
                    }), " TRAITER"]
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            defaultActiveKey: 1
          })]
        })
      })]
    }), currentCompany && selectedCandidates.length > 0 && /*#__PURE__*/_jsx(Drawer, {
      width: "90%",
      centered: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "CREATION FACTURE"
      }),
      open: showInvoice,
      onClose: function onClose() {
        setShowInvoice(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(Button, {
        type: "primary",
        style: {
          background: "#5B5757",
          marginRight: "10px"
        },
        onClick: function onClick() {
          setListConfirmed(listConfirmed == false ? true : false);
        },
        children: listConfirmed ? /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(ArrowLeftCircleFill, {
            size: 18
          }), " RETOUR"]
        }) : /*#__PURE__*/_jsxs("b", {
          children: ["SUIVANT ", /*#__PURE__*/_jsx(ArrowRightCircleFill, {
            size: 18
          })]
        })
      }), /*#__PURE__*/_jsx(Button, {
        loading: confirmLoading,
        disabled: !listConfirmed,
        type: "primary",
        style: {
          background: "#45736A",
          marginRight: "10px"
        },
        onClick: function onClick() {
          handleBillCreate();
        },
        children: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(CheckCircleFill, {
            size: 18
          }), " TERMINER"]
        })
      }), /*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref) {
            var handlePrint = _ref.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PrinterFill, {
                  size: 18
                }), " IMPRIMER"]
              })
            });
          }
        })
      })],
      children: listConfirmed ? /*#__PURE__*/_jsx(BillConfirm, {
        ref: ref,
        company: currentCompany,
        setCurCompany: setCurrentCompany,
        handler: function handler() {
          setDataChanged(true);
        },
        setAmount: setCurrentTotalAmount,
        candidates: selectedCandidates,
        from: from,
        to: to
      }) : /*#__PURE__*/_jsx(BillCheckList, {
        ref: ref,
        changeSelected: setSelectedCandidates,
        company: currentCompany,
        candidates: selectedCandidates,
        from: from,
        to: to
      })
    }), selectedBill && selectedBillCandidates.length > 0 && currentCompany && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showBill,
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS FACTURE"
        }),
        width: "90%",
        onClose: function onClose() {
          setShowBill(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(BillDisplay, {
          ref: ref,
          candidates: selectedBillCandidates,
          company: currentCompany
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showBillList,
        title: /*#__PURE__*/_jsx("b", {
          children: "LISTE DE CANDIDATS"
        }),
        width: "90%",
        onClose: function onClose() {
          setShowBillList(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref3) {
              var handlePrint = _ref3.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(BillCheckList, {
          ref: ref,
          candidates: selectedBillCandidates,
          company: currentCompany
        })
      })]
    })]
  });
};
export default Facturation;